module.exports = __webpack_public_path__ + "static/media/donate_success.ed35d889.png";